import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field, ErrorBox } from "@/components/common";
import { AuthFrame } from "@/pages/Login";
import { api, errMsg } from "@/lib/api";
import { useI18n } from "@/lib/i18n";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const { tx } = useI18n();
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return setErr(tx("Les mots de passe ne correspondent pas", "Passwords do not match"));
    try { await api.post("/auth/reset-password", { token: params.get("token"), password: pw }); setDone(true); } catch (e2) { setErr(errMsg(e2)); }
  };
  return (
    <AuthFrame title={tx("Nouveau mot de passe", "New password")} subtitle={tx("10 caractères minimum, lettres et chiffres.", "Minimum 10 characters, letters and digits.")}>
      {done ? (
        <div className="space-y-4" data-testid="reset-done">
          <p className="text-sm text-emerald-700">{tx("Mot de passe modifié. Toutes les sessions ont été fermées.", "Password changed. All sessions were closed.")}</p>
          <Button onClick={() => nav("/login")} data-testid="reset-goto-login">{tx("Se connecter", "Sign in")}</Button>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          {err && <ErrorBox error={err} />}
          <Field label={tx("Mot de passe", "Password")}><Input type="password" data-testid="reset-password-input" value={pw} onChange={(e) => setPw(e.target.value)} required /></Field>
          <Field label={tx("Confirmer", "Confirm")}><Input type="password" data-testid="reset-password-confirm" value={pw2} onChange={(e) => setPw2(e.target.value)} required /></Field>
          <Button type="submit" data-testid="reset-submit" className="w-full bg-[#153A63]">{tx("Enregistrer", "Save")}</Button>
        </form>
      )}
    </AuthFrame>
  );
}
